import { motion } from "framer-motion";
import { SearchX } from "lucide-react";

export default function EmptyState({ title = "Brak ofert", description, action, testid = "empty-state" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      data-testid={testid}
      className="flex flex-col items-center justify-center py-20 text-center relative"
    >
      <div className="absolute w-40 h-40 rounded-full bg-cyan-400/5 blur-3xl" />
      <SearchX className="w-16 h-16 text-slate-700 relative" strokeWidth={1} />
      <h3 className="font-display mt-6 text-xl font-medium text-slate-200 relative">{title}</h3>
      {description && <p className="mt-2 text-sm text-slate-500 max-w-sm relative">{description}</p>}
      {action && <div className="mt-6 relative">{action}</div>}
    </motion.div>
  );
}
